var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKebabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12.5 13a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12.5 19a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "#9FB0B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabIcon);
export default __webpack_public_path__ + "static/media/kebab-icon.0853e97320faaa33232aede3467b0f4d.svg";
export { ForwardRef as ReactComponent };